export default "__VITE_ASSET__DARiU83f__"